'use strict';

export class LoginCtrl
{
	
	$scope;
	jsDataService;
	
	recaptchaResponse;
	submitUrl = '';
	postData = {
		user: '',
		pass: ''
	};
	
	constructor($scope, jsDataService){
		'ngInject';
		this.$scope = $scope;
		this.jsDataService = jsDataService;
		this.submitUrl = this.jsDataService.get('submitUrl');
	}
	
	submitLogin(e){
		if(this.submitUrl){
			const self = this;
			const rec = self.jsDataService.get('recaptcha');
			if(rec){
				grecaptcha.ready(function() {
					grecaptcha.execute(rec.siteKey, {action: 'submit'}).then(function(token){
						self.recaptchaResponse = token;
						self.submitData(e);
					});
				});
			}
			else{
				self.submitData(e);
			}
			
		}
	}
	
	submitData(e){
		if(this.submitUrl){
			const self = this;
			let dat = this.postData;
			const rec = this.jsDataService.get('recaptcha');
			if(rec){
				dat[rec.field] = this.recaptchaResponse;
			}
			this.$scope.basicHttpConfigProcess({
				url: this.submitUrl,
				method: 'POST',
				responseType: 'json',
				data: dat
			});
		}
	}
}


